module.exports = __webpack_public_path__ + "media/images/pc/top/map-5a4d53fc5a611ddeda4dae7b1d28a1f8.png";